export enum rxReceivedScreenView {
  cart = 0,
  patientData = 1,
  shipping = 2,
  payment = 3,
  success = 4,
}

export enum rxEstimateScreenView {
  cart = 0,
  signup = 1,
  chooseSubscription = 2,
  basicinfo = 3,
}
